const RouterPaths = {
    config: '/config',
    configMain: '/config/main',
    configUsers: '/config/users/:uid?',
    forgot: '/forgot',
    login: '/login',
    logout: '/logout',
    main: '/',
    registration: '/registration',
    reset: '/reset',
    transactions: '/transactions/:uuid?',
};

export default RouterPaths;
